export default "__VITE_ASSET__BOx74jEi__"